import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Switch, Route, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'
import { logoutUser } from '../redux/userSlice';
import Contact from './Contact';
import logo from "../images/logo.png";
import login from "../images/login.png";
import logout from "../images/logout.png";
import account from "../images/account.png";
import background from "../images/background.jpeg";
import background3 from "../images/LouisReed.jpeg";

function NavBar() {

    const user = useSelector((state) => state.user.loggedin)
    const dispatch = useDispatch();
    const history = useHistory();
    const [open, setOpen] = useState(false)
    const [darkMode, setDarkMode] = useState(false)

    const handleDarkMode = () => {
        setDarkMode((darkMode) => !darkMode)
    }

    const handleClick = () => {
        setOpen((open) => !open)
    }

    const logoutClick = () => {
        localStorage.removeItem("token")
        localStorage.removeItem("user_id")
        localStorage.removeItem("user_registered")
        localStorage.removeItem("profile_store")
        localStorage.removeItem("tab-history")
        dispatch(logoutUser())
        history.push('/login')
    }

    return (
<> 
    {user ? ( 
        <>
            {darkMode ? <img src={background3} alt="background img" className="background-img"/>
            :
            <img src={background} alt="background img" className="background-img"/>}
        </>
        ):(
        <>
            <img src={background} alt="background img" className="background-img"/>
        </>
            )}

    <div className="whole-navbar">
        <div className="navbar-container">
            <div className="navbar">
               <Link to="/"><img src={logo} alt="Home" className="home-icon"/></Link>
               <Link to="/" className="home-text">FOTOSET</Link>
    {user ? (
        <>
            <ul
                className={open ? "hamburger active" : "hamburger"}
                onClick={handleClick}
            >
                <li></li>
                <li></li>
                <li></li>
            </ul>
            <ul className={open ? "items active" : "items"}>
                <Link to="/"><li>Home</li></Link>
                <li>Explore</li>
                <Link to="/account"><li>Account</li></Link>
                <li>About</li>
                <Link to="/contact"><li>Contact</li></Link>
            </ul>
                <div className="right-side"></div>
                <div className="right-side">
                <input type="checkbox" name="checkbox" className="checkbox" id="checkbox" onClick={handleDarkMode} />
                <label htmlFor="checkbox" className="label">
                    <i className="fas fa-moon"></i>
                    <i className="fas fa-lightbulb"></i>
                    <div className="ball"></div>
                </label>
                    <Link to="/account"><img src={account} alt="login icon" className="account-icon"/></Link>
                    <img src={logout} onClick={logoutClick} alt="login icon" className="logout-icon"/>
                </div>
            </> 
             ) : (
        <>
            <ul
                className={open ? "hamburger active" : "hamburger"}
                onClick={handleClick}
            >
                <li></li>
                <li></li>
                <li></li>
            </ul>
            <ul className={open ? "items active" : "items"}>
                <Link to="/"><li>Home</li></Link>
                <li>About</li>
                <Link to="/contact"><li>Contact</li></Link>
            </ul>
                <div className="right-side"></div>
                <div className="right-side">
                    <Link to="/login"><img src={login} alt="login icon" className="login-icon"/></Link>
                </div>
        </>
    )}
            </div>
        </div>
    </div> 
    <Switch>
        <Route exact path="/contact">
                <Contact darkMode={darkMode} />
        </Route>
    </Switch>
</>
      );
    }

export default NavBar;